export default {
  title: "Gelieerde bedrijven",

  table: {
    noData: "Nog geen gelieerde bedrijven",
  },

  input: {
    title: "Gelieerd bedrijf {{action}}",
    company: "Bedrijf",
    type: "Type",
  },
}
